import { Component, OnInit, Input, AfterViewInit } from '@angular/core';

import { FormGroup } from '@angular/forms';
import { UiFactory } from '../../core/ui/ui-factory';
import { CalendarModel } from '../../pg-field/pg-input-factory/calendar-model';
import { BehaviorService } from '../../core/behavior/behavior.service';

@Component({
  selector: 'pg-calendar-factory',
  templateUrl: './pg-calendar-factory.component.html',
  styleUrls: ['./pg-calendar-factory.component.scss'],
})
export class PgCalendarFactoryComponent extends UiFactory
  implements AfterViewInit {
  @Input() model: any;
  @Input() parentFormGroup: FormGroup;
  get calendarModel(): CalendarModel {
    return this.model;
  }

  constructor(public behaviorService: BehaviorService) {
    super(behaviorService);
  }

  ngOnInit() {
    super.ngOnInit();
  }
  ngAfterViewInit(): void {}
}
